'use client';

import clsx from 'clsx';
import { Slider as PecSlider, Slide as PrcSlide } from 'pure-react-carousel';

import styles from './Slider.module.css';
import { DefaultValue, CarouselProps } from './types';
import useCurrentSlide from './useCurrentSlide';

function Slider<V = DefaultValue>(props: CarouselProps<V>) {
  const {
    slideData,
    renderSlide,
    visibleSlides,
    carouselHeight,
    carouselPadding,
    slideContentClassName,
    sliderWrapperClass,
  } = props;
  const calcSlideContentHeight: string = carouselHeight || styles.mediumHeight;
  const calcCarouselPaddingBottom: string = carouselPadding || styles.basePadding;
  const slideClasses: string = clsx(styles.slide, calcCarouselPaddingBottom);
  const slideContentClasses: string = clsx(
    styles.slideContent,
    styles.slideContentTransition,
    calcSlideContentHeight,
    slideContentClassName,
  );
  const currentSlide: number = useCurrentSlide();

  return (
    <PecSlider draggable={false} className={styles.slider} classNameTrayWrap={sliderWrapperClass}>
      {slideData.map((data, index) => (
        <PrcSlide className={`${slideClasses} carousel-padding`} index={index} data-testid={`slide-${index}`} key={`slide-${index}`}>
          <div className={slideContentClasses}>{renderSlide(data, index, visibleSlides, currentSlide)}</div>
        </PrcSlide>
      ))}
    </PecSlider>
  );
}

export default Slider;
